<div class="contents">
  <app-search-bar [showPrimaryBtn]="false" [showFilterBtn]="true" (onFilterBtnClick)="showFilterModal()"
    (formValueChange)="handleFormValueChange($event)" class="ToTop"></app-search-bar>

  <div class="row">
    <ng-container *ngIf="pagination.data; else emptyTemplate">
      <app-table [pagination]="pagination" [columns]="columns" (pageChange)="onPageChange($event)"></app-table>
    </ng-container>
    <ng-template #emptyTemplate>
      <div class="no-data">
        <app-data-void titulo="Nenhum dado encontrado"
          descricao="Não foram encontrados dados financeiros"></app-data-void>
      </div>
    </ng-template>
  </div>

</div>

<p-dialog header="Filtros" [modal]="true" [(visible)]="showFilter" [style]="{ width: '40rem' }" appendTo="body">

  <form [formGroup]="form" class="p-fluid grid">
    <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
      <label>{{ filter.placeholder }}</label>

      <!-- Se for dropdown -->
      <p-select *ngIf="filter.type === 'dropdown'" [filter]="true" [showClear]="true" appendTo="body"
        [options]="filter.options" [formControlName]="filter.controlName" [placeholder]="filter.placeholder"
        [optionLabel]="filter.optionLabel" [optionValue]="filter.optionValue">
      </p-select>

      <!-- Se for texto -->
      <input *ngIf="filter.type === 'text'" pInputText [formControlName]="filter.controlName"
        [placeholder]="filter.placeholder" class="w-full" />
    </div>
  </form>


  <div class="flex items-center justify-content-between">
    <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
    <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
  </div>
</p-dialog>